import React, { useState, useContext } from 'react';
import { injectIntl } from 'react-intl';
import { useTheme } from 'ThemeContext';

import Logo from 'components/Logo';
import NavMenu from 'components/NavMenu';
import NavMenuLeft from 'components/NavMenuLeft';
import MenuList from 'components/MenuList';
import HeaderTooth from 'components/HeaderTooth';
import { AppSettingsContext } from 'AppSettingsContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';

import {
  Wrapper,
  Container,
  Box,
  LogoHolder,
  NavHolder,
  MenuHolder,
  TogglesHolder,
  ToggleButton
} from './Header.style';

function Header({
  intl,
  name = undefined,
  logo = undefined,
  mourning = false,
  navMenu = [],
  navMenuLeft = [],
  menu = []
}) {
  const [toggleNavMenu, setToggleNavMenu] = useState(false);
  const [toggleMenu, setToggleMenu] = useState(false);
  const theme = useTheme();
  const [appSettings] = useContext(AppSettingsContext);

  return (
    <>
      {logo || (navMenu && navMenu.length > 0) || (menu && menu.length > 0) ? (
        <>
          <Wrapper theme={theme.header.wrapper}>
            <Container
              widerTheme={appSettings.theme === 6 ? String(true) : undefined}
              narrowerTheme={appSettings.theme === 4 ? String(true) : undefined}
            >
              <Box theme={theme.header.box}>
                <LogoHolder theme={theme.header.logoHolder}>
                  {appSettings.theme === 6 ? (
                    <>
                      {logo && (
                        <Logo logo={logo} mourning={mourning} name={name} />
                      )}
                      <NavHolder>
                        <NavMenuLeft
                          menu={navMenuLeft}
                          toggle={true}
                          setToggle={setToggleNavMenu}
                        />
                      </NavHolder>
                    </>
                  ) : logo ? (
                    <Logo logo={logo} mourning={mourning} name={name} />
                  ) : (
                    <NavHolder>
                      <NavMenuLeft
                        menu={navMenuLeft}
                        toggle={toggleNavMenu}
                        setToggle={setToggleNavMenu}
                      />
                    </NavHolder>
                  )}

                  <TogglesHolder>
                    {navMenu && navMenu.length > 0 ? (
                      <ToggleButton
                        theme={theme.header.toggleButton}
                        title={intl.formatMessage({
                          id: 'HEADER.TOGGLE_NAV_MENU'
                        })}
                        toggle={toggleNavMenu ? true : undefined}
                        onClick={() => {
                          setToggleMenu(false);
                          setToggleNavMenu(!toggleNavMenu);
                        }}
                      >
                        <FontAwesomeIcon icon={faBars} />
                      </ToggleButton>
                    ) : (
                      ''
                    )}
                    <ToggleButton
                      theme={theme.header.toggleButton}
                      title={intl.formatMessage({
                        id: 'HEADER.TOGGLE_MENU'
                      })}
                      toggle={toggleMenu ? true : undefined}
                      onClick={() => {
                        setToggleNavMenu(false);
                        setToggleMenu(!toggleMenu);
                      }}
                    >
                      <FontAwesomeIcon icon={faBars} />
                    </ToggleButton>
                  </TogglesHolder>
                </LogoHolder>

                {navMenu && navMenu.length > 0 ? (
                  <NavHolder>
                    <NavMenu
                      menu={navMenu}
                      toggle={toggleNavMenu}
                      setToggle={setToggleNavMenu}
                    />
                  </NavHolder>
                ) : (
                  ''
                )}
                {menu && menu.length > 0 ? (
                  <MenuHolder>
                    <MenuList
                      menu={menu}
                      toggle={toggleMenu}
                      setToggle={setToggleMenu}
                    />
                  </MenuHolder>
                ) : (
                  ''
                )}
              </Box>
            </Container>
            {theme.header.toothing && <HeaderTooth />}
          </Wrapper>
        </>
      ) : (
        ''
      )}
    </>
  );
}

export default injectIntl(Header);
